import {useUserPreferencesPartial} from '@data/queries/preferences/userPreferences.main'
import classnames from '@helpers/misc/classnames'
import {getPath} from '@helpers/router/getPathname'
import Link from 'next/link'
import {useRouter} from 'next/router'
import {Suspense} from 'react'
import {comparePaths} from './comparePaths'

type NavbarLinksProps = {
  links: any[]
  navbarCustomStyle: React.CSSProperties
}

function InnerNavbarLinks(props: Readonly<NavbarLinksProps>) {
  const {links, navbarCustomStyle} = props
  const router = useRouter()
  const userPreferences = useUserPreferencesPartial()
  const isLoggedIn = userPreferences?.data?.userPreferences?.userId
  const linkClass = 'appSubtitle !text-lg !mb-0 inline-block py-1.25 text-inherit'
  const linksAvailable = isLoggedIn ? links : links.filter(link => !link.showLoggedIn)

  const renderLinks = (link, index) => {
    if (!link.path.startsWith('/')) {
      return (
        <a
          href={link.path}
          target="_blank"
          key={index}
          className={classnames(linkClass, '!font-normal')}
          rel="noopener noreferrer"
        >
          {link.title}
        </a>
      )
    }
    const currentPath = getPath(router)
    const comparedPaths = comparePaths(currentPath, link.path)
    const active = comparedPaths.samePath && comparedPaths.sameSearch
    return (
      <Link
        href={link.path}
        passHref
        key={index}
        onClick={e => {
          if (active) e.preventDefault()
        }}
        className={classnames(linkClass, {
          '!font-normal': !active,
          '!font-bold': active,
        })}
      >
        {link.title}
      </Link>
    )
  }

  return (
    <div className="mainNavbar" style={navbarCustomStyle}>
      <div
        className={
          'mx-auto flex flex-row justify-start items-center px-4 py-5 max-w-[100dvw] md:max-w-[1200px] border-y'
        }
      >
        <div className="flex-1 w-full">
          <div className={classnames('flex text-left overflow-y-auto touch-auto space-x-8')}>
            {linksAvailable.map((link, index) => {
              return renderLinks(link, index)
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export function DesktopNavbarLinksSkeleton() {
  return <div className="h-[70px] w-full animate-pulse bg-gray-100 dark:bg-zinc-800" />
}

export default function DesktopNavbarLinks(props: Readonly<NavbarLinksProps>) {
  const {links} = props
  if (links?.length <= 1) return null
  return (
    <Suspense fallback={<DesktopNavbarLinksSkeleton />}>
      <InnerNavbarLinks {...props} />
    </Suspense>
  )
}
